import axios from "axios";
import { Toast } from 'cube-ui'

import config from "../config";

const baseUrl = config.baseUrl
const clientId = config.clientID;

// import store from '../store';
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

let loadingToast = null

function showLoading () {
  if (loadingToast) {
    loadingToast.show()
    return
  }
  loadingToast = Toast.$create({
    txt: 'Loading...',
    type: 'loading',
    time: 0,
    mask: true
  })
  loadingToast.show()
}

function clearLoading () {
  if (!loadingToast) return
  loadingToast.hide()
  loadingToast = null
}

function showMsg (message) {
  Toast.$create({
    txt: message,
    type: 'txt',
    time: 1000
  }).show()
}

// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: 'http://localhost:8081/api/v1',
  baseURL: baseUrl,

  // 超时
  timeout: 20000
})


// request拦截器
service.interceptors.request.use(config => {

  // 是否需要设置 token
  const token =localStorage.getItem("token")
  config.headers['Authorization'] = 'Bearer ' + token // 让每个请求携带自定义token 请根据实际情况自行修改
  config.headers['clientid'] =  clientId
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?';
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof(value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            if (value[key] !== null && typeof (value[key]) !== 'undefined') {
              let params = propName + '[' + key + ']';
              let subPart = encodeURIComponent(params) + '=';
              url += subPart + encodeURIComponent(value[key]) + '&';
            }
          }
        } else {
          url += part + encodeURIComponent(value) + "&";
        }
      }
    }
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  return config
}, error => {
  //store.commit('hideLoading')
  clearLoading()
  console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    //store.commit('hideLoading')
    clearLoading()
    //console.log(res)
    // 未设置状态码则默认成功状态
    const code = res.code || 200;
    console.log('code:'+code)
    // 获取错误信息
    const msg =  res.data.message || 'server error'
    if (code === 445 ) {
      showMsg("异地登陆")
      console.log('---401')
    }else if (code === 500) {
      showMsg(msg)
      return Promise.reject(new Error(msg))
    } else if (code !== 200) {
      showMsg(msg)
      return Promise.reject('error')
    } else {
      if(code==200) {
        if(res.data.code==401) {
          localStorage.removeItem('token')
          window.location.href = '/login'
        }

        if(res.data.code==444) {
          window.location.href = '/login'
        }
      }
      return res.data
    }
  },
  error => {
    //store.commit('hideLoading')
    clearLoading()
    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = "Network Error";
    }
    else if (message.includes("timeout")) {
      message = "request timeout";
    }
    else if (message.includes("Request failed with status code")) {
      message = "system api " + message.substr(message.length - 3) + " error";
    }
    showMsg(message)
    return Promise.reject(error)
  }
)


export default service



// WEBPACK FOOTER //
// ./src/utils/request.js